// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {FormattedMessage} from 'react-intl';
import WarrantyDateRangePicker from '../../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';

const ClaimHistoryCreditMemoDate = props =>
    <section className='claim-history-credit-memo-date form-group'>
        <label className='form-group-title'>
            <FormattedMessage id={props.label}/>
        </label>
        <WarrantyDateRangePicker
            dateRange={props.dateRange}
            maxDate={props.dateRange.max}
            minDate={props.dateRange.min}
            onDateChange={props.onDateChange}
        />
    </section>;

ClaimHistoryCreditMemoDate.displayName = 'ClaimHistoryCreditMemoDate';
ClaimHistoryCreditMemoDate.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    label: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default ClaimHistoryCreditMemoDate;




// WEBPACK FOOTER //
// ./src/reports/claim-history/components/claim-history-report-criteria/date-criteria.js